module.exports = __webpack_public_path__ + "img/143.twice_a_year.08cfee17.svg";